import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import StaffCertificationAddFile from './StaffCertificationAddFile';
import getLocale from '../../../i18n/getLocale';

class StaffCertificationsTypeTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      date_start: '',
      date_finish: '',
      pf: 0,
      night_landings: 0,
      only_active: 1,
      certification_id: null,
      certification_supplier_id: null,
      observations: '',
      staff_certifications: [],
      certifications: [],
      certification_suppliers: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.activate = this.activate.bind(this);
    this.delete = this.delete.bind(this);
    this.archive = this.archive.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  handleSelectChangeCertification(name, event) {
    this.props.handleAlert('', '', 'open');
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({certification_suppliers: responseJson.data});
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });      
      }
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.certifications) && Array.isArray(newProps.staff_certifications_other_type) && this.state.loaded === false) {
      this.setState({
        certifications: newProps.certifications,
        staff_certifications: newProps.staff_certifications_other_type,
        loaded: true
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.props.staff_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      pf: this.state.pf,
      night_landings: this.state.night_landings,
      certification_id: this.state.certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.refreshData();
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch ativando um item
  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.ativar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if(self.state.only_active === 0){
              self.refreshDataActive();
            } else{      
              self.refreshData();
            }
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  // Fetch deletando um item
  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.arquivar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/certificado/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if(self.state.only_active === 0){
              self.refreshDataActive();
            } else{      
              self.refreshData();
            }
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  // Fetch deletando um item
  delete(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/certificado/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if(self.state.only_active === 0){
              self.refreshDataActive();
            } else{      
              self.refreshData();
            }
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  refreshData () {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/certificados/tipo/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 0});
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive () {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/certificados/ativos/tipo/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 1});
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tituloAvaliacoes}</h3>
  <hr/>
  <button className="btn btn-sm btn-warning btn-block" onClick={self.state.only_active === 0 ? self.refreshDataActive.bind(self, self.state.staff_certifications) : self.refreshData.bind(self, self.state.staff_certifications)}>{self.state.only_active === 0 ? this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.botaoEsconderArquivoMorto : this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.botaoMostrarArquivoMorto}</button>
  <hr/>
  {(this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined') ?  <div><small><em>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.nenhumCertificadoCadastrado}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.NomeDoCertificado}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Inicio}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Fim}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Status}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Arquivo}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_certifications).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_certifications[k].certification}</td>
              <td className="text-center">{self.state.staff_certifications[k].date_start_str}</td>
              <td className="text-center">{self.state.staff_certifications[k].date_finish_str}</td>
              <td className="text-center">
                {(self.state.staff_certifications[k].expire_status_int === 0) ?  <span className="text text-success">{self.state.staff_certifications[k].expire_str}</span> : <span className="text text-danger">{self.state.staff_certifications[k].expire_str}</span>}
              </td>
              <td className="text-center">{(self.state.staff_certifications[k].active === 1) ?  <span className="label label-success">{self.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                <StaffCertificationAddFile handleAlert={self.props.handleAlert} refreshData={self.refreshData} staff_certification_id={self.state.staff_certifications[k].id} file={self.state.staff_certifications[k].file} file_archived={self.state.staff_certifications[k].file_archived} />
              </td>
              <td className="text-center">
                {(self.state.staff_certifications[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_certifications[k].id} onClick={self.archive}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_certifications[k].id} onClick={self.activate}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-danger" value={self.state.staff_certifications[k].id} onClick={self.delete}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.tituloCadastrarCertificado}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.Certificado}:</label>
          <Select
            className="form-field-name"
            name="certification_id"
            value={this.state.certification_id}
            searchable={true}
            placeholder={this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.placeholder.SelecionarCertificado}
            onChange={this.handleSelectChangeCertification.bind(this, 'certification_id')}
            options={this.state.certifications}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.Fornecedor}:</label>
          <Select
            className="form-field-name"
            name="certification_supplier_id"
            value={this.state.certification_supplier_id}
            searchable={true}
            placeholder={this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.placeholder.SelecionarFornecedor}
            onChange={this.handleSelectChange.bind(this, 'certification_supplier_id')}
            options={this.state.certification_suppliers}
          />
        </div>
      </div>
    </div>
    <div className="row">
    <div className="col-md-3 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.DataDeInicio}:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.DataFinal}:</label>
        <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.CargaHoraria}:</label>
        <input value={this.state.pf} name="pf" className="form-control" onChange={this.handleChange.bind(this, 'pf')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.QuantidadeDePousosNoturnos}:</label>
        <input value={this.state.night_landings} name="night_landings" className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-12 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.Observacoes}:</label>
        <textarea value={this.state.observations} name="observations" className="form-control" onChange={this.handleChange.bind(this, 'observations')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.EditarFuncionario.tabAvaliacoes.formulario.botaoSalvarCertificado}</button>
  </form>
</div>
    );
  }
}

export default StaffCertificationsTypeTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffCertificationsTypeTab.js